// extracted by mini-css-extract-plugin
export default {"left-item-wrapper":"qtpc_","leftItemWrapper":"qtpc_"};